export const sidebarMenus = [
    {
        title: 'Dashboard', 
        icon: '/assets/icons/Dashboard.svg',
        link: '/',
        roles: ["admin", "superadmin", "moderator", "attendance"],
        subMenus: []
    },
    {
        title: 'Offices', 
        icon: '/assets/icons/Shop.svg',
        link: '/offices',
        roles: ["superadmin", "admin", "attendance"],
        subMenus: []
    },
    {
        title: 'News Update', 
        icon: '/assets/icons/News.svg',
        link: '/posts',
        roles: ["superadmin", "admin", "moderator"],
        subMenus: []
    },
    {
        title: 'Employees', 
        icon: '/assets/icons/Employees.svg',
        link: '/employees',
        roles: ["attendance", "moderator"],
        subMenus: []
    },
    {
        title: 'Employees', 
        icon: '/assets/icons/Employees.svg',
        link: '',
        roles: ["superadmin", "admin"],
        subMenus: [
            {
                subTitle: 'Employees',
                link: '/employees',
            },
            {
                subTitle: 'Employee Status',
                link: '/employee-status',
            },
            {
                subTitle: 'Eselon',
                link: '/eselons',
            },
            {
                subTitle: 'Position',
                link: '/positions',
            },
        ]
    },
    {
        title: 'Points', 
        icon: '/assets/icons/Audios.svg',
        link: '',
        roles: ["superadmin", "admin", "moderator"],
        subMenus: [
            {
                subTitle: 'Rewards',
                link: '/rewards',
            },
            {
                subTitle: 'Log Rewards',
                link: '/log-rewards',
            },
            {
                subTitle: 'Log Points',
                link: '/points',
            },
        ]
    },
    // {
    //     title: 'Eslon', 
    //     icon: '/assets/icons/Gallery.svg',
    //     link: '/echelons',
    //     roles: ["superadmin"],
    //     subMenus: []
    // },
    // {
    //     title: 'Position', 
    //     icon: '/assets/icons/Gallery.svg',
    //     link: '/positions',
    //     roles: ["superadmin"],
    //     subMenus: []
    // },
    {
        title: 'Attendances', 
        icon: '/assets/icons/Report-Attendance.svg',
        link: '',
        roles: ["superadmin", "attendance"],
        subMenus: [
            {
                subTitle: 'Attendances',
                link: '/attendances',
            },
            {
                subTitle: 'Lembur/WFA',
                link: '/ovt',
            },
            {
                subTitle: 'Absents',
                link: '/absents',
            },
            {
                subTitle: 'Report',
                link: '/attendances-report',
            },
        ]
    },
    {
        title: 'Informations', 
        icon: '/assets/icons/Information.svg',
        link: '/informations',
        roles: ["superadmin", "attendance"],
        subMenus: []
    },
    {
        title: 'Utilities', 
        icon: '/assets/icons/Gallery.svg',
        link: '/utilities',
        roles: ["superadmin", "attendance"],
        subMenus: []
    },
]